export default "__VITE_ASSET__D5hN2W18__"